import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import LoginFormComponent from "./loginForm";
import PublicHeader from "../../../layout/publicLayout/header";

interface LoginComponentInterface {
  onFinish: any;
}

const LoginComponent: React.FC<LoginComponentInterface> = (props) => {
  const { onFinish } = props;
  return (
    <div className="auth-page">
      <PublicHeader isLogin={true} />
      <Row className="auth-page_row">
        <Col span={14} xs={20} sm={20} md={14} lg={10}>
          <div className="auth-form-wrapper">
            <h2>Log in</h2>

            <LoginFormComponent onFinish={onFinish} />
            <div className="auth-page__forgotPassword">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoginComponent;
